import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { ThemeProvider } from './contexts/ThemeContext';
import { ToastProvider } from './contexts/ToastContext';
import { ProgressProvider } from './components/TopProgressBar';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <ThemeProvider>
      <ProgressProvider>
        <ToastProvider>
          <App />
        </ToastProvider>
      </ProgressProvider>
    </ThemeProvider>
  </React.StrictMode>
);
